export default {
  'VIDEO' (state) {
    return state.video
  },
  'VIDEOS' (state) {
    return state.videos
  }
}
